export default __webpack_public_path__ + "static/media/330_portfolio04-en-web.b4cd4313.png";